"use client"

import React from "react"

export default function PageHeading({
  title,
  description,
}: {
  title: string
  description: string
}) {
  return (
    <header className="tw:flex tw:flex-col tw:gap-1 tw:py-4">
      <h1 className="tw:text-2xl tw:font-semibold tw:leading-8 tw:text-foreground">
        {title}
      </h1>
      <p className="tw:text-sm tw:font-medium tw:leading-5 tw:text-muted-foreground">
        {description}
      </p>
    </header>
  )
}
